import type { ProductionReason } from "./models";

export type DowntimeVoiceDraft = { reasonCodeId: string; customMode: boolean; customReason: string; note: string };

const normalized = (value: string) => value.toLocaleLowerCase("tr-TR").normalize("NFKD")
  .replace(/[\u0300-\u036f]/g, "").replace(/ı/g, "i").replace(/[^a-z0-9]/g, "");

/**
 * A voice transcript can select a catalogue reason only when it says that name
 * exactly. Everything else stays operator-owned custom text; we do not guess a
 * production classification from free speech.
 */
export function applyDowntimeVoiceTranscript(reasons: ProductionReason[], draft: DowntimeVoiceDraft, transcript: string) {
  const text = transcript.trim();
  if (!text) return { draft, error: "Ses kaydında kullanılabilir bir metin yok." } as const;
  const exactReasons = reasons.filter((reason) => reason.category === "DOWNTIME" && normalized(reason.name) === normalized(text));
  if (exactReasons.length === 1) return { draft: { ...draft, reasonCodeId: exactReasons[0].id, customMode: false, customReason: "" }, error: null } as const;
  if (text.length < 3) return { draft, error: "Duruş nedenini en az üç karakter söyleyin veya klavyeyle girin." } as const;
  const note = text.length > 160 ? [draft.note.trim(), text].filter(Boolean).join("\n") : draft.note;
  if (note.length > 500) return {
    draft,
    error: "Ses metni 500 karakteri aşıyor. Kaydı kısaltın veya klavyeyle nedenini girin; mevcut taslak değiştirilmedi.",
  } as const;
  return {
    draft: { ...draft, reasonCodeId: "", customMode: true, customReason: text.slice(0, 160), note },
    error: null,
  } as const;
}
